import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import { BADGE, FONT_SIZE } from "../../../../theme/tokens";

/**
 * The one count treatment used across the dropdown (segmented tab, Select-all `(N)`, pill trigger) —
 * a soft brand-tinted rounded badge. Polish #3: standardize every count on this style.
 */
export const CountBadge: FC<{ count: number }> = ({ count }) => (
	<Box
		component="span"
		sx={(theme) => ({
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			minWidth: BADGE.PILL_SIZE,
			px: 0.75,
			py: "1px",
			borderRadius: BADGE.PILL_RADIUS_FULL,
			fontSize: FONT_SIZE.CAPTION,
			fontWeight: 600,
			lineHeight: 1.4,
			color: theme.palette.primary.dark,
			backgroundColor: alpha(theme.palette.primary.main, 0.1),
		})}
	>
		{count}
	</Box>
);
